// extracted by mini-css-extract-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_Jyt","cls2":"ChurnedUserReactivationButton-cls2_eaQ ChurnedUserReactivationButton-cls1_Jyt"};